// @flow
import React, { useCallback, useContext, useState } from 'react';
import axios from 'axios';
import { rootUrl } from '../../../config';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import StoreContext from '../../../state/context/store';
import {
  setSearchResults,
  setSearchTerm,
  setSearching,
  setSelectedSpecialization,
  setSelectedDisciplines,
  setSelectedMedicalDisciplines,
  setSelectedMedicalSubDisciplines,
  setSelectedLocations,
  setSelectedInterests,
  setSelectedRaces,
  setSelectedGenders,
  setSelectedLanguages,
  setActiveDisplay,
} from '../../../state/actions/search';
import MetricsManager from '../../../service/metrics';
import { SnackContext } from '../../../state/context/snack';
import { Button } from '@material-ui/core';
import { LayoutContext } from '../../../state/context/layout';
import SearchBox from '../../SearchBox';

const mm = MetricsManager.getInstance();

const LandingSearch = (props) => {
  const { t } = useTranslation();
  const [store, dispatch] = useContext(StoreContext);
  const { search } = store;
  const { isSearching } = search;
  const [searchValue, setSearchValue] = useState(search.searchTerm);
  const { placeholder, history } = props;

  const { setAction, setMessage, setSeverity } = useContext(SnackContext);
  const { phoneActive } = useContext(LayoutContext);

  const searchWomen = useCallback(() => {
    setSearchResults(dispatch, []);
    //clear any stored filters
    setSelectedSpecialization(dispatch, null);
    setSelectedDisciplines(dispatch, []);
    setSelectedMedicalDisciplines(dispatch, []);
    setSelectedMedicalSubDisciplines(dispatch, []);
    setSelectedLocations(dispatch, []);
    setSelectedInterests(dispatch, []);
    setSelectedRaces(dispatch, []);
    setSelectedGenders(dispatch, []);
    setSelectedLanguages(dispatch, []);

    const cleanedSearch = searchValue.trim();

    setSearching(dispatch, true);
    axios
      .post(
        `${rootUrl}/api/search`,
        {
          search: cleanedSearch.trim(),
        },
        {
          withCredentials: true,
        }
      )
      .then((results) => {
        setSearchTerm(dispatch, cleanedSearch);
        setActiveDisplay(dispatch, 'search');
        //if search is too large, warn user
        if (results.data.error) {
          setAction(true);
          setMessage(
            `${t('search.tooLarge_part1')} ${Number(
              results.data.total
            ).toLocaleString(undefined, {
              minimumFractionDigits: 0,
            })} ${t('search.tooLarge_part2')}.`
          );
          setSeverity('warning');
          //snack attack
          return;
        }

        setSearchResults(dispatch, results.data);

        mm.addMetrics(
          results.data.map((r) => {
            return {
              userId: r.userId,
              appId: 1, //gage
              gageProfileId: r.id,
              podProfileId: null,
              metric: 'search',
            };
          })
        );
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setSearching(dispatch, false);
        if (cleanedSearch.length) history.push(`/search?q=${cleanedSearch}`);
        else history.push('/search');
      });
  }, [history, searchValue, dispatch, setAction, setMessage, setSeverity, t]);

  const handleKeyPress = useCallback(
    (event) => {
      setSearchValue(event.target.value);
      if (event.key === 'Enter') {
        searchWomen();
      }
    },
    [searchWomen]
  );

  const clearSearch = () => {
    setSearchValue('');
  };

  return (
    <div className={styles.container}>
      <SearchBox
        placeholder={placeholder}
        value={searchValue}
        clear={clearSearch}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        onKeyDown={handleKeyPress}
        search={searchWomen}
      />
      <Button
        className={`${styles.search} ${
          phoneActive ? styles.search_mobile : null
        }`}
        onClick={searchWomen}
        // disabled={true}
        variant="outlined"
      >
        {phoneActive ? t('Go') : t('Explore')}{' '}
        {isSearching && (
          <i
            className={`${styles.spinner} fas fa-circle-notch fa-spin`}
            style={{ width: '16px', height: '16px', fontSize: '16px' }}
          ></i>
        )}
      </Button>
    </div>
  );
};

export default LandingSearch;
